import { l as m } from "../../../_virtual/leaflet-src.js";
import { useEffect as t } from "react";
import { createOverlayComponent as c } from "../../@react-leaflet/core/lib/generic.js";
import { createElementObject as s } from "../../@react-leaflet/core/lib/element.js";
const L = c(function(n, p) {
  const e = new m.Popup(n, p.overlayContainer);
  return s(e, p);
}, function(n, p, { position: e }, r) {
  t(function() {
    const { instance: o } = n;
    function a(u) {
      u.popup === o && (o.update(), r(!0));
    }
    function f(u) {
      u.popup === o && r(!1);
    }
    return p.map.on({
      popupopen: a,
      popupclose: f
    }), p.overlayContainer == null ? (e != null && o.setLatLng(e), o.openOn(p.map)) : p.overlayContainer.bindPopup(o), function() {
      var i;
      p.map.off({
        popupopen: a,
        popupclose: f
      }), (i = p.overlayContainer) == null || i.unbindPopup(), p.map.removeLayer(o);
    };
  }, [
    n,
    p,
    r,
    e
  ]);
});
export {
  L as Popup
};
